import { Button, Dropdown } from "antd";
import { DashOutlined } from "@ant-design/icons";

const DropdownButton = ({ index, dropdownMenuForSmallNavForTheWebsite }) => {
  return (
    <>
      <Dropdown
        overlay={dropdownMenuForSmallNavForTheWebsite(index)}
        placement="bottomRight"
      >
        <Button
          style={{
            lineHeight: "1.499",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            fontWeight: "600",
            borderRadius: "4px",
            borderColor: "#d9d9d9",
            color: "#777B7C",
            height: "30px",
            width: "30px",
            textAlign: "center",
            marginLeft: "8px",
          }}
        >
          <DashOutlined />
        </Button>
      </Dropdown>
    </>
  );
};

export default DropdownButton;
